export function safeString(s) {
    return typeof s === "string"
        ? s
        : "";
}
//# sourceMappingURL=safeString.js.map